import { createContext, forwardRef, useRef } from 'react';
import { motion, useInView } from 'motion/react';
import { REVEAL_MARGIN } from '../../utils/animations';

// In-view state of the surrounding ComponentWrapper, for children that run
// their own entrance animations (e.g. AnimateSplitLines). Defaults to null so
// consumers rendered outside a wrapper can tell no wrapper is present and
// fall back to their own in-view detection.
export const ComponentInViewContext = createContext(null);

const ComponentWrapper = forwardRef(function ComponentWrapper(
  {
    block,
    className = '',
    children,
    padding = true,
    scrollTrigger = false,
    // colorDynamic = false,
  },
  forwardedRef
) {
  // const theme = block?.theme ?? 'white';
  // const theme = false;

  const combinedClassName = `Component ${className} ${
    padding ? 'ComponentPadding' : ''
  } ${block?.colorCopy ? `colorCopy` : block?.theme == 'dynamic' ? `colorDynamicComponent` : ''} ${
    block?.colorBackground ? `colorDynamicBg` : 'colorWhiteBg'
  }`.trim();
  // }`.trim();
  // } colorDynamicBg ${theme ? `theme--${theme} colorDynamicBg` : ''}`.trim();

  const inViewRef = useRef(null);
  const isInView = useInView(inViewRef, {
    once: true,
    margin: REVEAL_MARGIN,
  });

  // Attach both the forwarded ref and the in-view ref to the section.
  const assignRef = (node) => {
    inViewRef.current = node;
    if (typeof forwardedRef === 'function') forwardedRef(node);
    else if (forwardedRef) forwardedRef.current = node;
  };

  // Conditionally render motion.section or regular section
  if (scrollTrigger) {
    return (
      <motion.section
        ref={assignRef}
        animate={isInView ? 'visible' : 'hidden'}
        className={combinedClassName}
        {...(block?.blockId ? { 'data-anchor': block.blockId } : {})}
      >
        <ComponentInViewContext.Provider value={isInView}>
          {children}
        </ComponentInViewContext.Provider>
      </motion.section>
    );
  }

  return (
    <section
      ref={assignRef}
      className={combinedClassName}
      {...(block?.blockId ? { 'data-anchor': block.blockId } : {})}
    >
      {/* <ComponentInViewContext.Provider value={isInView}> */}
      {children}
      {/* </ComponentInViewContext.Provider> */}
    </section>
  );
});

export default ComponentWrapper;
